/**
 * Partner Configuration for Rocket Van Express Partnership Landing Pages
 * Each partner gets a custom co-branded page at /partners/:slug
 */

export const partnerConfig = {
  // University Partners
  'uct': {
    slug: 'uct',
    name: 'University of Cape Town',
    shortName: 'UCT',
    logo: null,
    tagline: 'Official Student Moving Partner',
    description: 'Rocket Van Express is the trusted moving partner for UCT students. Whether you\'re moving into res, relocating off-campus, or heading home for the holidays, we offer student-friendly rates and reliable service.',
    primaryColor: '#003366',
    discount: '15% student discount',
    discountCode: 'UCT15',
    services: ['student-moves', 'box-delivery', 'storage-runs', 'furniture-delivery'],
    areas: ['Rondebosch', 'Mowbray', 'Observatory', 'Newlands', 'Claremont', 'Cape Town CBD', 'Southern Suburbs'],
    testimonial: {
      quote: 'Moving out of res was so stressful until I found Rocket Van Express. They were affordable, on time, and super careful with my stuff!',
      author: 'Jessica van Wyk',
      role: 'BSc Student, UCT'
    },
    contact: null,
    featured: true
  },

  'stellenbosch-university': {
    slug: 'stellenbosch-university',
    name: 'Stellenbosch University',
    shortName: 'Maties',
    logo: null,
    tagline: 'Matie Moving Partner',
    description: 'Rocket Van Express is the go-to moving service for Stellenbosch University students. From koshuis moves to apartment relocations, we understand the unique needs of Maties and offer special rates.',
    primaryColor: '#8B2942',
    discount: '20% Matie discount',
    discountCode: 'MATIE20',
    services: ['student-moves', 'box-delivery', 'storage-runs', 'furniture-delivery'],
    areas: ['Stellenbosch CBD', 'Die Boord', 'Kayamandi', 'Paradyskloof', 'Idas Valley', 'Dalsig', 'Universiteitsoord'],
    testimonial: {
      quote: 'Best moving service in Stellies! Moved my whole room from koshuis to a flat in under 2 hours. Super affordable for students.',
      author: 'Pieter Botha',
      role: 'BA Student, Matie'
    },
    contact: null,
    featured: true
  },

  'uwc': {
    slug: 'uwc',
    name: 'University of the Western Cape',
    shortName: 'UWC',
    logo: null,
    tagline: 'UWC Student Moving Partner',
    description: 'Rocket Van Express proudly serves the University of the Western Cape community with affordable, reliable moving services. We understand student budgets and offer special rates for UWC students.',
    primaryColor: '#003366',
    discount: '15% UWC student discount',
    discountCode: 'UWC15',
    services: ['student-moves', 'box-delivery', 'storage-runs'],
    areas: ['Bellville', 'Parow', 'Goodwood', 'Kuilsriver', 'Brackenfell', 'Northern Suburbs'],
    testimonial: {
      quote: 'Affordable and reliable - exactly what students need. Rocket Van Express made moving stress-free.',
      author: 'Themba Williams',
      role: 'Law Student, UWC'
    },
    contact: null,
    featured: true
  },

  'cput': {
    slug: 'cput',
    name: 'Cape Peninsula University of Technology',
    shortName: 'CPUT',
    logo: null,
    tagline: 'CPUT Student Moving Partner',
    description: 'Rocket Van Express is the preferred moving service for CPUT students across all campuses. Whether you\'re at Bellville, District Six, or Granger Bay, we offer convenient student rates.',
    primaryColor: '#00539B',
    discount: '15% CPUT student discount',
    discountCode: 'CPUT15',
    services: ['student-moves', 'box-delivery', 'storage-runs'],
    areas: ['Bellville', 'Cape Town CBD', 'Granger Bay', 'Mowbray', 'Woodstock', 'Salt River'],
    testimonial: {
      quote: 'Moving between CPUT campuses was easy with Rocket Van Express. Great prices for students!',
      author: 'Ayanda Nkosi',
      role: 'IT Student, CPUT'
    },
    contact: null,
    featured: true
  },

  // Business Partners
  'oak-furniture': {
    slug: 'oak-furniture',
    name: 'Oak Furniture Store',
    logo: null,
    tagline: 'Official Delivery Partner',
    description: 'Rocket Van Express is the official delivery partner for Oak Furniture Store. Get your furniture delivered safely with our white-glove service.',
    primaryColor: '#8B4513',
    discount: '10% off',
    discountCode: 'OAK10',
    services: ['furniture-delivery', 'assembly-assistance', 'old-furniture-removal'],
    areas: ['Stellenbosch', 'Somerset West', 'Cape Town'],
    testimonial: {
      quote: 'Rocket Van Express has been delivering our furniture for over a year. Their care and professionalism is unmatched.',
      author: 'Johan van der Berg',
      role: 'Owner, Oak Furniture Store'
    },
    contact: {
      email: 'partner@example.com',
      phone: '+27 21 123 4567'
    },
    featured: false
  },
  
  'bidorbuy': {
    slug: 'bidorbuy',
    name: 'bidorbuy',
    logo: null,
    tagline: 'Trusted Delivery Partner',
    description: 'Ship your bidorbuy purchases safely with Rocket Van Express. We handle marketplace deliveries with care and provide real-time tracking.',
    primaryColor: '#FF6B00',
    discount: 'Free tracking',
    discountCode: null,
    services: ['marketplace-delivery', 'secure-handling', 'photo-proof'],
    areas: ['Western Cape'],
    testimonial: null,
    contact: null,
    featured: false
  },
  
  'cape-properties': {
    slug: 'cape-properties',
    name: 'Cape Properties',
    logo: null,
    tagline: 'Moving Partner for New Homeowners',
    description: 'Moving to your new home? Cape Properties clients get exclusive rates on mini-moves with Rocket Van Express.',
    primaryColor: '#1E3A5F',
    discount: '15% off mini-moves',
    discountCode: 'CAPEMOVE15',
    services: ['mini-moves', 'furniture-delivery', 'box-delivery'],
    areas: ['Stellenbosch', 'Paarl', 'Franschhoek'],
    testimonial: {
      quote: 'We recommend Rocket Van Express to all our clients. They make moving day stress-free.',
      author: 'Sarah Williams',
      role: 'Sales Director, Cape Properties'
    },
    contact: {
      email: 'moves@capeproperties.co.za',
      phone: '+27 21 555 1234'
    },
    featured: false
  }
};

// Service descriptions for partner pages
export const partnerServices = {
  'furniture-delivery': {
    title: 'Furniture Delivery',
    description: 'Safe delivery of furniture with blanket wrapping and secure handling',
    icon: 'Sofa'
  },
  'assembly-assistance': {
    title: 'Assembly Assistance',
    description: 'Help with basic furniture assembly on delivery',
    icon: 'Wrench'
  },
  'old-furniture-removal': {
    title: 'Old Furniture Removal',
    description: 'We can remove your old furniture when delivering new items',
    icon: 'Trash2'
  },
  'marketplace-delivery': {
    title: 'Marketplace Delivery',
    description: 'Secure delivery of online marketplace purchases',
    icon: 'ShoppingBag'
  },
  'secure-handling': {
    title: 'Secure Handling',
    description: 'Extra care for valuable or fragile items',
    icon: 'Shield'
  },
  'photo-proof': {
    title: 'Photo Proof',
    description: 'Photo documentation at pickup and delivery',
    icon: 'Camera'
  },
  'mini-moves': {
    title: 'Mini-Moves',
    description: 'Full mini-move service with helpers',
    icon: 'Truck'
  },
  'box-delivery': {
    title: 'Box Delivery',
    description: 'Delivery of boxes and packed items',
    icon: 'Package'
  },
  'student-moves': {
    title: 'Student Moves',
    description: 'Affordable moves designed for student budgets',
    icon: 'GraduationCap'
  },
  'storage-runs': {
    title: 'Storage Runs',
    description: 'Transport to and from storage facilities',
    icon: 'Warehouse'
  }
};

// Get partner by slug
export const getPartnerBySlug = (slug) => {
  return partnerConfig[slug] || null;
};

// Get all featured partners
export const getFeaturedPartners = () => {
  return Object.values(partnerConfig).filter(p => p.featured);
};

// Get all partner slugs (for sitemap)
export const getAllPartnerSlugs = () => {
  return Object.keys(partnerConfig);
};

// Get university partners only
export const getUniversityPartners = () => {
  const universitySlugs = ['uct', 'stellenbosch-university', 'uwc', 'cput'];
  return universitySlugs.map(slug => partnerConfig[slug]).filter(Boolean);
};

export default partnerConfig;
